import { BaseStyledComponentProps, NewStyleColor } from '../../utils/styles-constants';
import { spin } from '../../utils/style';
import styled, { css } from 'styled-components';
import { LoaderStepName } from './index';

const loader = css`
	cursor: default;
	display: flex;
	align-items: center;
	justify-content: center;

	& > :last-child {
		margin: 0 5px;
	}

	& > svg {
		position: relative;
		animation: ${spin};
	}
`;

interface LoaderProps {
	step: LoaderStepName;
}

const LoaderVariants: ({}) = {
	['Button']: styled('div') `${css`
		${loader}
		& > svg {
			height: 25px;
			width: 25px;
			margin-left: ${(props: LoaderProps) => props.step === LoaderStepName.DownloadingAll ? `-25px` : `0`};
			margin-right: ${(props: LoaderProps) => props.step === LoaderStepName.DownloadingAll ? `15px` : `5px`};
		}
	`}`,
	['Overlay']: styled('div')`${css`
		${loader}
		background: ${(props: BaseStyledComponentProps) => props.theme.primary.backgroundColor};
		color: ${(props: BaseStyledComponentProps) => props.theme.primary.strongColor};
		opacity: 0.9;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 4;
		border-radius: 7px;

		& > svg {
			height: 30px;
			width: 30px;
			margin-right: 5px;
		}
	`}`,
	['ListItem']: styled('div')`${css`
		${loader}
		background: ${(props: BaseStyledComponentProps) => props.theme.primary.backgroundColor};
		color: ${(props: BaseStyledComponentProps) => props.theme.primary.strongColor};
		opacity: 0.9;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		padding-bottom: 5px;
		z-index: 4;
		border-radius: 7px;
		text-align: center;
		box-sizing: border-box;

		svg {
			height: 20px;
			width: 20px;
			margin-right: 5px;
			animation: ${spin};
			${(props: LoaderProps) => (props.step === LoaderStepName.Deleting || props.step === LoaderStepName.DeletingDependencies)
					&& `fill: ${NewStyleColor.Red300};`}
		}

		${(props: LoaderProps) => (props.step === LoaderStepName.Downloading || props.step === LoaderStepName.Deleting) && `
			flex-wrap: wrap;

			> span {
				padding-top: 5px;
			}

			> div {
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 5px;
				padding-bottom: 0;
			}

			svg {
				margin-right: 10px;
			}
		`}
		${(props: LoaderProps) => (props.step === LoaderStepName.DownloadingDependencies || props.step === LoaderStepName.DeletingDependencies)
				&& 'padding: 5px;'}
		${(props: LoaderProps) => (props.step === LoaderStepName.Deleting || props.step === LoaderStepName.DeletingDependencies)
				&& `color: ${NewStyleColor.Red300};`}
	`}`
};

export { LoaderVariants };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Loader/styles.ts